@if (addLayerService.isLayerInfoLoading()) {
    <app-loading />
} @else {
    @if (Object.keys(addLayerService.geomLayersInfo()).length) {
        <app-table-layer-list-info
            [columns]="allColumns()"
            [hasFieldInterventions]="hasFieldInterventions()"
            [hasGeomProperty]="true"
            [isInterstandardFolderSelected]="isInterstandardFolderSelected()"
            [layerInfo]="addLayerService.geomLayersInfo()"
            [layerType]="layerType()"
            [title]="'geographicLayers' | transloco" />
    }
    @if (unresolvedGeomServiceCatalogs().length) {
        <div class="m-3 flex flex-col gap-2">
            @for (error of unresolvedGeomServiceCatalogs(); track error.serviceCatalogId) {
                <div class="service-catalog-error-row service-catalog-error-row-with-geom">
                    <span class="truncate">{{ error.layerName }}</span>
                    <div class="service-catalog-error-icon">
                        <fa-icon
                            class="text-custom-dark-grey"
                            [icon]="['fas', 'eye-slash']" />
                    </div>
                    <span class="service-catalog-error-pill"></span>
                </div>
                <p class="text-sm text-error">
                    {{ 'missingFluxLayerInCatalog' | transloco: { layerName: error.layerName } }}
                </p>
            }
        </div>
    }
    @if (Object.keys(addLayerService.noGeomLayersInfo()).length) {
        <app-table-layer-list-info
            [columns]="noGeomColumns()"
            [hasFieldInterventions]="hasFieldInterventions()"
            [hasGeomProperty]="false"
            [isInterstandardFolderSelected]="isInterstandardFolderSelected()"
            [layerInfo]="addLayerService.noGeomLayersInfo()"
            [layerType]="layerType()"
            [title]="'attributeLayers' | transloco" />
    }
    @if (unresolvedNoGeomServiceCatalogs().length) {
        <div class="m-3 flex flex-col gap-2">
            @for (error of unresolvedNoGeomServiceCatalogs(); track error.serviceCatalogId) {
                <div class="service-catalog-error-row service-catalog-error-row-no-geom">
                    <span class="truncate">{{ error.layerName }}</span>
                </div>
                <p class="text-sm text-error">
                    {{ 'missingFluxLayerInCatalog' | transloco: { layerName: error.layerName } }}
                </p>
            }
        </div>
    }
}
